import request from "../request";

/**
 * Состояние корзины
 * @return {Promise}
 */
export const getCart = ({ eventId }) => {
  return request({
    url: "/event/cart/get-cart",
    addCSRFToken: true,
    needOverlay: false,
    data: {
      event_id: eventId || 0,
    },
  });
};

/**
 * Добавление в корзину
 * @return {Promise}
 */
export const addToCart = ({ eventId, sid, viewId, price_view_id }) => {
  return request({
    url: "/event/cart/add",
    addCSRFToken: true,
    data: {
      event_id: eventId,
      sid,
      view_id: viewId,
      price_view_id,
    },
  });
};

/**
 * Удаляет билет из корзины
 * @param {Object} props
 * @param {number} props.eventId
 * @param {string} props.sid
 * @param {number} props.viewId
 * @param {string} props.uid
 * @return {Promise<import("../types/cart").RemoveEventCartResponse>}
 */
export const removeFromCart = ({ eventId, sid, viewId, uid }) => {
  return request({
    url: "/event/cart/remove",
    addCSRFToken: true,
    type: "DELETE",
    data: {
      event_id: eventId,
      sid,
      uid,
      view_id: viewId,
    },
  });
};

/**
 * Удалить мероприятия из заказа
 * @return {Promise}
 */
export const removeEventFromOrder = ({ eventId, orderId }) => {
  return request({
    url: "/event/cart/remove-event",
    data: {
      event_id: eventId,
      order_id: orderId,
    },
  });
};

export const cancelAll = () => {
	return request({
		url: "/order/cancel-all",
	})
}
/**
 * Меняет тип билета
 * @return {Promise}
 */
export const changePriceId = ({
  eventId,
  orderId,
  uid,
  priceId,
  categoryId,
}) => {
  return request({
    url: "/event/cart/change-price-id",
    data: {
      event_id: eventId,
      order_id: orderId,
      uid: uid,
      price_id: priceId,
      loyalty_category_id: categoryId,
    },
  });
};

export const saveExtraInfo = ({ uid, text }) => {
  return request({
    url: "/event/cart/save-extra-info",
    data: {
      uid,
      text,
    },
  });
};

/**
 * Список доступных доп. услуг сделки и уже добавленных.
 * @param {Object} props
 * @param {number} props.eventId
 * @param {number|string} [props.index] - uid позиции билета (occupied.uid); null — по всей сделке
 * @return {Promise}
 */
export const getAdditionals = ({ eventId, index }) => {
  const data = {
    event_id: eventId,
  };

  if (index) data.index = index;

  return request({
    url: "/event/cart/additionals",
    addCSRFToken: true,
    needOverlay: false,
    data,
  });
};

/**
 * Добавляет доп. услугу к заказу (к позиции билета)
 * @param {Object} props
 * @param {number} props.eventId
 * @param {number} props.orderId
 * @param {number} props.parentUid
 * @param {number} props.serviceId
 * @param {number} [props.priceTypeId]
 * @param {number|string} [props.index] - uid позиции билета, по которой показан список услуг
 * @return {Promise}
 */
export const addAdditional = ({
  eventId,
  orderId,
  parentUid,
  serviceId,
  priceTypeId,
  index,
}) => {
  const data = {
    event_id: eventId,
    order_id: orderId,
    parent_uid: parentUid,
    service_id: serviceId,
    price_type_id: priceTypeId,
  };

  if (index) data.index = index;

  return request({
    url: "/event/cart/additionals-add",
    addCSRFToken: true,
    data,
  });
};

/**
 * Удаляет добавленную доп. услугу из заказа
 * @param {Object} props
 * @param {number} props.eventId
 * @param {number} props.orderId
 * @param {number} props.uid
 * @param {number|string} [props.index] - uid позиции билета, по которой показан список услуг
 * @return {Promise}
 */
export const removeAdditional = ({ eventId, orderId, uid, index }) => {
  const data = {
    event_id: eventId,
    order_id: orderId,
    uid,
  };

  if (index) data.index = index;

  return request({
    url: "/event/cart/additionals-remove",
    addCSRFToken: true,
    type: "DELETE",
    data,
  });
};
